( function( $ ) {
	document.body.classList.remove( 'no-js' );
	document.body.classList.add( 'js' );
} )( jQuery );
